import React from 'react';
import { t } from '@lingui/macro';
import CollectionModal from 'modals/CollectionModal/CollectionModal';
import { useCollectionModalContext } from 'modals/CollectionModal/CollectionModalContext';
import { ModalsEnum } from 'types/enums';
import { ModalProps } from 'modals/Modal.types';

const EditCollectionModal: React.FC<ModalProps> = ({ handleClose, isOpen }) => {
    const { collection } = useCollectionModalContext();

    return (
        <CollectionModal
            title={t`Rename collection`}
            submitButtonText={t`Save`}
            modalType={ModalsEnum.editCollectionModal}
            collection={collection}
            handleClose={handleClose}
            isOpen={isOpen}
        />
    );
};

export default EditCollectionModal;
